import { FunctionComponent } from "react";
import { StyledCopy } from "./copy.styles";
import { showError, showSuccess } from "lib/notification";
import { faCopy } from "./icon-library";

interface CopyProps {
  value: string;
}

const Copy: FunctionComponent<CopyProps> = ({ value }) => {
  const handleCopy = () => {
    if (location.protocol !== "https:") {
      showError("Leikepöytä käytössä vain HTTPS-yhteydellä!");
      return;
    }

    try {
      navigator.clipboard.writeText(value);
      showSuccess("Teksti kopioitu leikepöydälle!");
    } catch (err) {
      console.error(err);
      showError("Leikepöydälle kopiointi epäonnistui!");
    }
  };

  return <StyledCopy icon={faCopy} onClick={handleCopy} />;
};

export default Copy;
